import type { ModeTokens } from '../tokens';

const porcelainSage: ModeTokens = {
  light: {
    surface: {
      base: '#F2F1EC',
      raised: '#FBFAF6',
      sunken: '#E7E7E1',
      overlay: 'rgba(23,24,26,0.45)',
    },
    text: {
      primary: '#1E201D',
      secondary: '#55574F',
      muted: '#7D7F77',
      onAccent: '#FBFAF6',
      onDanger: '#FBFAF6',
    },
    border: {
      subtle: '#E3E4DD',
      default: '#CFD1C8',
      strong: '#9FA299',
      focus: '#5F7A64',
    },
    accent: {
      default: '#5F7A64',
      hover: '#4E6753',
      pressed: '#3F5544',
      soft: '#D7DFD3',
    },
    status: {
      success: { bg: '#E1ECDF', fg: '#274E31' },
      warning: { bg: '#F5E8D0', fg: '#6A4A12' },
      danger: { bg: '#F1DCD9', fg: '#7A2E26' },
      info: { bg: '#DDE3EA', fg: '#2A3E57' },
    },
  },
  dark: {
    surface: {
      base: '#17181A',
      raised: '#1F2122',
      sunken: '#101112',
      overlay: 'rgba(0,0,0,0.6)',
    },
    text: {
      primary: '#E8E9E3',
      secondary: '#A6A89F',
      muted: '#7A7C73',
      onAccent: '#17181A',
      onDanger: '#17181A',
    },
    border: {
      subtle: '#2C2F2E',
      default: '#3A3D3B',
      strong: '#5E615E',
      focus: '#8BA890',
    },
    accent: {
      default: '#8BA890',
      hover: '#A0BCA4',
      pressed: '#B7CDBA',
      soft: '#2B332C',
    },
    status: {
      success: { bg: '#22322A', fg: '#B9D5BE' },
      warning: { bg: '#3A2F1A', fg: '#E8C98A' },
      danger: { bg: '#3A221F', fg: '#F0B3AB' },
      info: { bg: '#222A36', fg: '#B7CAE2' },
    },
  },
};

export default porcelainSage;
